import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html'
})

/**
 * Footer Component
 */
export class FooterComponent implements OnInit {
  constructor() {}
  /***
   * Current year
   */
  year: number = new Date().getFullYear();

  ngOnInit(): void {}
}
